import { render, staticRenderFns } from "./trawl-card.vue?vue&type=template&id=2d0cdd1c"
import script from "./trawl-card.vue?vue&type=script&lang=js"
export * from "./trawl-card.vue?vue&type=script&lang=js"
import style0 from "./trawl-card.vue?vue&type=style&index=0&id=2d0cdd1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports